/** @module form */

/**
 * Funktionalität zum Spam-Schutz bei Formularen
 * @property {NodeList} captcha Nodelist of Captcha HTMLElements
 */
export class OpaccFormElementCaptcha {
	constructor() {
		this.captcha = document.querySelectorAll('.wpCaptchaButton');
		this.attachEventListener();
		this.init();
	}

	init() {
		let googleRecaptchaElems = document.querySelectorAll('input.g-recaptcha-response[type="hidden"]');

		if (googleRecaptchaElems.length == 0) {
			return;
		}

		Array.from(googleRecaptchaElems).forEach(elem => {
			this.renderGoogleRecaptcha(elem);
		})
	}

	/**
	 * Event Registrierungen im DOM
	 */
	attachEventListener() {
		Array.from(this.captcha).forEach(button => {
			button.removeAttribute('onclick');
			button.addEventListener('click', () => {
				let parent = button.parentNode;
				if(parent){
					let id = parent.querySelector('.wpCaptchaInput').getAttribute('name').replace('wpCaptchaInput_', '');
					parent.querySelector('img').setAttribute('src', `/WebPortal/ShowCaptcha.aspx?id=${id}&time=${Date.now()}`);
				}
			});
		});
	}

	renderGoogleRecaptcha(reCaptcha) {
		let reCaptchaObj = this.getReCaptchaConfig(reCaptcha);

		reCaptchaObj.formSubmitBtn.addEventListener('click', () => {
			if (reCaptchaObj.reCaptchaSiteKey && reCaptchaObj.reCaptchaAction) {
                window.grecaptcha.ready(() => {
                    window.grecaptcha.execute(reCaptchaObj.reCaptchaSiteKey, {action: reCaptchaObj.reCaptchaAction}).then(token => {
                        reCaptchaObj.reCaptchaRespElem.value = token;

                        reCaptchaObj.selectedForm.dispatchEvent(new Event('submit'));
                    });
                });
			} else {
				throw new Error('Opacc formvalidator: Google reCAPTCHA is not configured.');
			}
		})

	}

	getReCaptchaConfig(elem) {
		let returnObj = {
			reCaptchaRespElem: elem,
			reCaptchaSiteKey: elem.dataset.opSitekey ? elem.dataset.opSitekey : '',
			reCaptchaAction: elem.dataset.opAction ? elem.dataset.opAction : '',
			selectedForm: elem.closest('form'),
			formSubmitBtn: elem.closest('form').querySelector('[type="submit"]')
		};

		return returnObj;
	}
}